<microsec-loading-overlay [isLoading]="!!isLoading">
  <microsec-card [isDetailCard]="true">
    @if (!!device) {
      <p-tabs [scrollable]="true" class="microsec-dashboard-tab" [value]="0">
        <p-tablist>
          <p-tab [value]="0">Overview</p-tab>
          <p-tab [value]="1">VLANs</p-tab>
          <p-tab [value]="2">Firewalls</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <app-network-device-overview [device]="device" />
          </p-tabpanel>
          <p-tabpanel [value]="1">
            <app-shared-vlans [device]="device" />
          </p-tabpanel>
          <p-tabpanel [value]="2">
            <app-shared-firewalls [device]="device" />
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }
  </microsec-card>
</microsec-loading-overlay>
